import React from 'react';
import { useABTest } from '../ab-test-context';
import { ABTestContext } from '../../common/ab-test-provider';
import { useProductContext } from '../product-router';
import { ProductProvider, Products } from '../../common/product-context';
export var LegacyContextConverter = function LegacyContextConverter(_ref) {
  var _products$;
  var children = _ref.children;
  var _useProductContext = useProductContext(),
    products = _useProductContext.products;
  var abTest = useABTest();
  return /*#__PURE__*/React.createElement(ProductProvider, {
    products: products.map(function (product) {
      switch (product.id) {
        case 'confluence':
          return Products.confluence;
        case 'jira':
          return Products.jira;
        default:
          return Products.other;
      }
    }),
    activeIndex: products.findIndex(function (product) {
      return product.isDisplayed;
    }),
    primaryProduct: (_products$ = products[0]) === null || _products$ === void 0 ? void 0 : _products$.title
  }, /*#__PURE__*/React.createElement(ABTestContext.Provider, {
    value: {
      abTest: abTest || null
    }
  }, children));
};